import qs from 'query-string';
import axios from 'api/api.config';
import {useQuery} from 'react-query';

export const REPORT_BA_VISITOR_QUERY_KEY = {
  VISITOR_LIST: 'VISITOR_LIST',
  VISITOR_DETAIL: 'VISITOR_DETAIL',
  VISITOR_ANALYTICS: 'VISITOR_ANALYTICS',
};

export function useAnalyticBAVisitorList({ filter, body }) {
  return useQuery([REPORT_BA_VISITOR_QUERY_KEY.VISITOR_ANALYTICS, { filter, body }, body], () =>
      axios.post(`/api/v1/admin/analytic-store-traffic/list?${qs.stringify(filter)}`, body).then((res) => res.data)
  );
}

export function useReportBAVisitorList({ filter, body }) {
  return useQuery([REPORT_BA_VISITOR_QUERY_KEY.VISITOR_LIST, { filter, body }, body], () =>
    axios.post(`/api/v1/admin/store-traffic?${qs.stringify(filter)}`, body).then((res) => res.data)
  );
}

export function useReportBAVisitorDetails(recordId) {
  return useQuery([REPORT_BA_VISITOR_QUERY_KEY.VISITOR_DETAIL, recordId], () =>
      axios.get(`/api/v1/admin/store-traffic/detail/${recordId}`).then((res) => res.data)
  );
}
